/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_ECO_DRIVE, URL_GRAPHS } from '../../../router/constants';
import { ecoDriveWidgetGraphAtom, isGraphOpenAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import EcoDriveOnline from '../../Graphs/EcoDrive/EcoDriveOnline';

function EcoDriveWidgetGraph(props: any): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [ecoDriveWidgetGraph, setEcoDriveWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    ecoDriveWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    trackEvent(['EcoDrive Widget', 'click', 'Close widget graph']);
    setEcoDriveWidgetGraph(null);
    setIsGraphOpen(false);
    localforage.setItem('widgetGraph', null);
  };

  const openEcoDrivePage = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    trackEvent(['EcoDrive Widget', 'click', 'Open EcoDrive page to new window']);
    window.open(`${URL_GRAPHS}${URL_ECO_DRIVE}/${ecoDriveWidgetGraph?.vehicleId}`, '_blank');
  };

  React.useEffect(() => {
    trackEvent(['EcoDrive Widget', 'show', 'Widget graph']);
    return () => {
      if (ecoDriveWidgetGraph && ecoDriveWidgetGraph.timestamp !== undefined) {
        setEcoDriveWidgetGraph(null);
        localforage.setItem('widgetGraph', null);
        trackEvent(['EcoDrive Widget', 'close', 'Widget graph']);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDate = () => {
    if (ecoDriveWidgetGraph && ecoDriveWidgetGraph.timestamp) {
      return dayjs(ecoDriveWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  return (
    <div style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}>
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {f({ id: 'rides.ecoScore' })}: {getDate()}
          </div>
          <button
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openEcoDrivePage}
          >
            {f({ id: 'table.detailBtn' })}
          </button>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <EcoDriveOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}

export default EcoDriveWidgetGraph;
